module.exports = __webpack_public_path__ + "js/1.d3414097.bundle.worker.js"